import * as React from 'react'

export type RowProps = React.ComponentPropsWithoutRef<'tr'>

export const Row = ({ children, ...restProps }: RowProps) => (
  <tr {...restProps}>{children}</tr>
)
